import { useState, useEffect } from 'react';

export function formatDate(dateString: string | null | undefined): string {
    if (!dateString) return '';
    return new Date(dateString).toISOString().substring(0, 10);
}

export function formatTime(timeString: string): string {
    if (!timeString || !/^\d{2}:\d{2}(:\d{2})?$/.test(timeString)) return timeString;
    return timeString.slice(0, 5);
}

export const formatDecimalIfNeeded = (num: number | string | null | undefined): string => {
    if (num === null || num === undefined) return '';
    const numericValue = Number(num);
    if (isNaN(numericValue)) return String(num);
    return Number(numericValue.toPrecision(15)).toString();
};

export function formatJobNumber(job: string | null | undefined): string {
    if (!job) return '';
    const jobNumber = parseInt(job, 10);
    if (isNaN(jobNumber) || jobNumber === 0) return '';
    return String(jobNumber);
}

export function isPoInRange(poNumberStr: string, seriesPrefixes: number[]): boolean {
    if (!poNumberStr || seriesPrefixes.length === 0) return false;
    const poPrefix = parseInt(poNumberStr.replace(/\D/g, '').substring(0, 6), 10);
    if (isNaN(poPrefix)) return false;
    return seriesPrefixes.includes(poPrefix);
}

export const currencyFormatter = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' });